import get from 'lodash.get';

export const selectAlertDetails = (state) => get(state, 'alertDetails');
export const selectAlertId = (state) => get(state, 'alertId');
